import { render, staticRenderFns } from "./Attachment_list.vue?vue&type=template&id=7bfed29b&scoped=true"
import script from "./Attachment_list.vue?vue&type=script&lang=js"
export * from "./Attachment_list.vue?vue&type=script&lang=js"
import style0 from "./Attachment_list.vue?vue&type=style&index=0&id=7bfed29b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfed29b",
  null
  
)

export default component.exports